export const translations = {
  en: {
    nav: { mission: "Mission", causes: "Causes", campaigns: "Campaigns", wall: "Donor Wall", donate: "Donate", donateNow: "Donate Now", about: "About", contact: "Contact" },
    hero: {
      overline: "A Non-Profit for Humanity · Est. Bharat",
      l1: "Serving the divine", l2: "in every soul we", l3: "choose to uplift.",
      desc: "Findivine channels compassion into action — for women, animals, children, the underserved, and our shared spiritual roots.",
      cta: "Begin Giving",
    },
    marquee: ["Women Empowerment", "Animal Welfare", "Child Education", "Weaker Section Welfare", "Hindu Religious Empowerment"],
    impact: { overline: "Our impact so far" },
    story: { eyebrow: "Who we are", badge: "Seva is our worship. Every act, an offering.", cta: "Join our mission →", fallbackTitle: "Our Mission" },
    testimonials: { eyebrow: "Voices", fallbackTitle: "Stories of impact" },
    manifesto: {
      overline: "Our Manifesto",
      items: [
        { t: "Compassion is our first principle.", b: "We believe seva — selfless service — is the truest form of worship. Findivine exists to turn devotion into tangible relief for those who need it most." },
        { t: "Every rupee reaches the ground.", b: "From sanitary dignity in Rusirani to fodder for our sacred cows and books for Jaipur's children — we fund projects, not overhead. Transparency is sacred to us." },
        { t: "Rooted in Dharma, open to all.", b: "Grounded in Hindu values of karuna and daan, we serve women, animals, children and the economically weaker — without expectation, without exception." },
      ],
    },
    causes: {
      overline: "What we stand for",
      title: "Five pillars, one shared devotion to service.",
      items: [
        { title: "Women Empowerment", text: "Dignity, health and opportunity for women across rural India." },
        { title: "Animal Welfare", text: "Care and fodder for cows and voiceless beings." },
        { title: "Child Education", text: "Books, stationery and a future for every child." },
        { title: "Weaker Section Welfare", text: "Support for the economically underserved." },
        { title: "Hindu Religious Empowerment", text: "Preserving dharma, temples and spiritual heritage." },
      ],
    },
    campaigns: {
      overline: "Live Campaigns", title: "Three projects raising funds right now.",
      of: "of", donate: "Donate to this cause",
    },
    donate: {
      overline: "Make a difference", title: "Give once, or give every month.",
      oneTime: "One-time", monthly: "Monthly · Auto-debit",
      chooseCause: "Choose a cause", amount: "Amount (₹)", custom: "Custom amount",
      fullName: "Full name", phone: "Phone", email: "Email", yourName: "Your name",
      methodUpi: "UPI QR", methodCard: "Card / Netbanking",
      paidUpi: "I've paid ₹{a} via UPI", setupMonthly: "Set up ₹{a}/month auto-debit", donateSecure: "Donate ₹{a} securely",
      ackNote: "A thank-you acknowledgement email is sent for every donation.",
      weakerSection: "Weaker Section Welfare", hindu: "Hindu Religious Empowerment", general: "Where it's needed most",
      scanTitle: "Scan to donate via UPI",
      scanDesc: "Scan with any UPI app to pay Findivine directly, then tap “I've paid via UPI”.",
      notReady: "Not ready to give?", notReadyDesc: "Leave your details and we'll keep you close to the mission.",
      message: "Message (optional)", stayConnected: "Stay connected", sending: "Sending...",
      thanksDonation: "Thank you! Your donation is recorded — an acknowledgement email is on its way. 🙏",
      thanksVisitor: "Thank you! We'll stay in touch. 🌼",
      cardActivating: "Card payments are being activated. Please use the UPI QR to donate instantly.",
      fillDetails: "Please fill your name, email and phone.", validAmount: "Please enter a valid amount.",
      paySuccess: "Payment successful! Acknowledgement email on its way. 🙏",
    },
    wall: {
      overline: "Wall of Changemakers",
      title: "The faces behind the change.",
      desc: "Give ₹10,000 in one go — or ₹2,000 a month for five months — and be featured here forever. Monthly patrons appear after their 5th deduction. As new patrons join, our wall grows brighter.",
      addPhoto: "Get featured — give ₹10,000+",
      dialogTitle: "Join the Wall of Changemakers",
      dialogDesc: "Featured for a one-time gift of ₹10,000 or more. (Monthly ₹2,000 × 5 patrons are added automatically after the 5th deduction.)",
      name: "Your name", donationAmount: "One-time donation amount (₹)", choosePhoto: "Choose a photo",
      submit: "Add me to the wall", uploading: "Uploading...",
      featured: "Featured Patron", founding: "Founding Patron",
      minError: "The Wall features one-time gifts of ₹10,000+, or ₹2,000/month completed over 5 months.",
      needPhoto: "Please choose a photo.", success: "Welcome to the Wall of Changemakers! 🙏",
      empty: "Be the first face on our wall.",
      emptyDesc: "No changemakers featured yet — a gift of ₹10,000 or more puts your photo here first.",
    },
    footer: { getInTouch: "Get in touch", title: "Your compassion has a home here.", donateNow: "Donate Now", admin: "Admin", explore: "Explore", contactCol: "Contact" },
  },
  hi: {
    nav: { mission: "हमारा ध्येय", causes: "कारण", campaigns: "अभियान", wall: "दानदाता दीवार", donate: "दान करें", donateNow: "अभी दान करें", about: "हमारे बारे में", contact: "संपर्क" },
    hero: {
      overline: "मानवता के लिए एक ग़ैर-लाभकारी संस्था · भारत",
      l1: "हर आत्मा में", l2: "बसे दिव्यता की", l3: "सेवा में समर्पित।",
      desc: "फ़ाइंडिवाइन करुणा को कर्म में बदलती है — महिलाओं, पशुओं, बच्चों, वंचितों और हमारी साझा आध्यात्मिक जड़ों के लिए।",
      cta: "दान शुरू करें",
    },
    marquee: ["महिला सशक्तिकरण", "पशु कल्याण", "बाल शिक्षा", "कमज़ोर वर्ग कल्याण", "हिंदू धार्मिक सशक्तिकरण"],
    impact: { overline: "अब तक हमारा प्रभाव" },
    story: { eyebrow: "हम कौन हैं", badge: "सेवा ही हमारी पूजा है। हर कर्म, एक अर्पण।", cta: "हमारे मिशन से जुड़ें →", fallbackTitle: "हमारा ध्येय" },
    testimonials: { eyebrow: "आवाज़ें", fallbackTitle: "प्रभाव की कहानियाँ" },
    manifesto: {
      overline: "हमारा संकल्प",
      items: [
        { t: "करुणा ही हमारा पहला सिद्धांत है।", b: "हम मानते हैं कि सेवा — निःस्वार्थ सेवा — पूजा का सच्चा रूप है। फ़ाइंडिवाइन भक्ति को उन लोगों तक ठोस राहत में बदलने के लिए है जिन्हें इसकी सबसे अधिक ज़रूरत है।" },
        { t: "हर रुपया ज़मीन तक पहुँचता है।", b: "रुसिरानी में स्वच्छता की गरिमा से लेकर हमारी गौमाता के चारे और जयपुर के बच्चों की किताबों तक — हम परियोजनाओं को धन देते हैं, ख़र्चों को नहीं। पारदर्शिता हमारे लिए पवित्र है।" },
        { t: "धर्म में निहित, सबके लिए खुला।", b: "करुणा और दान के हिंदू मूल्यों में निहित, हम महिलाओं, पशुओं, बच्चों और आर्थिक रूप से कमज़ोर वर्ग की सेवा करते हैं — बिना किसी अपेक्षा, बिना किसी भेद के।" },
      ],
    },
    causes: {
      overline: "हम किसके लिए खड़े हैं",
      title: "पाँच स्तंभ, सेवा के लिए एक साझा समर्पण।",
      items: [
        { title: "महिला सशक्तिकरण", text: "ग्रामीण भारत की महिलाओं के लिए गरिमा, स्वास्थ्य और अवसर।" },
        { title: "पशु कल्याण", text: "गायों और मूक प्राणियों के लिए देखभाल और चारा।" },
        { title: "बाल शिक्षा", text: "हर बच्चे के लिए किताबें, स्टेशनरी और एक भविष्य।" },
        { title: "कमज़ोर वर्ग कल्याण", text: "आर्थिक रूप से वंचितों के लिए सहयोग।" },
        { title: "हिंदू धार्मिक सशक्तिकरण", text: "धर्म, मंदिरों और आध्यात्मिक विरासत का संरक्षण।" },
      ],
    },
    campaigns: {
      overline: "चल रहे अभियान", title: "अभी तीन परियोजनाएँ धन जुटा रही हैं।",
      of: "में से", donate: "इस कारण के लिए दान करें",
    },
    donate: {
      overline: "बदलाव लाएँ", title: "एक बार दें, या हर महीने दें।",
      oneTime: "एक बार", monthly: "मासिक · ऑटो-डेबिट",
      chooseCause: "एक कारण चुनें", amount: "राशि (₹)", custom: "अन्य राशि",
      fullName: "पूरा नाम", phone: "फ़ोन", email: "ईमेल", yourName: "आपका नाम",
      methodUpi: "UPI QR", methodCard: "कार्ड / नेटबैंकिंग",
      paidUpi: "मैंने UPI से ₹{a} का भुगतान किया", setupMonthly: "₹{a}/माह ऑटो-डेबिट सेट करें", donateSecure: "₹{a} सुरक्षित रूप से दान करें",
      ackNote: "हर दान के लिए एक धन्यवाद ईमेल भेजा जाता है।",
      weakerSection: "कमज़ोर वर्ग कल्याण", hindu: "हिंदू धार्मिक सशक्तिकरण", general: "जहाँ सबसे ज़रूरत हो",
      scanTitle: "UPI से दान के लिए स्कैन करें",
      scanDesc: "किसी भी UPI ऐप से स्कैन करके फ़ाइंडिवाइन को सीधे भुगतान करें, फिर “मैंने UPI से भुगतान किया” पर टैप करें।",
      notReady: "अभी दान के लिए तैयार नहीं?", notReadyDesc: "अपनी जानकारी छोड़ें और हम आपको मिशन से जोड़े रखेंगे।",
      message: "संदेश (वैकल्पिक)", stayConnected: "जुड़े रहें", sending: "भेजा जा रहा है...",
      thanksDonation: "धन्यवाद! आपका दान दर्ज हो गया है — धन्यवाद ईमेल जल्द ही आ रहा है। 🙏",
      thanksVisitor: "धन्यवाद! हम संपर्क में रहेंगे। 🌼",
      cardActivating: "कार्ड भुगतान सक्रिय किया जा रहा है। कृपया तुरंत दान के लिए UPI QR का उपयोग करें।",
      fillDetails: "कृपया अपना नाम, ईमेल और फ़ोन भरें।", validAmount: "कृपया एक वैध राशि दर्ज करें।",
      paySuccess: "भुगतान सफल! धन्यवाद ईमेल जल्द ही आ रहा है। 🙏",
    },
    wall: {
      overline: "परिवर्तन-नायकों की दीवार",
      title: "बदलाव के पीछे के चेहरे।",
      desc: "एक बार में ₹10,000 दें — या पाँच महीने तक हर महीने ₹2,000 — और यहाँ हमेशा के लिए प्रदर्शित हों। मासिक दानदाता अपनी 5वीं कटौती के बाद दिखते हैं। जैसे-जैसे नए दानदाता जुड़ते हैं, हमारी दीवार और उज्जवल होती जाती है।",
      addPhoto: "प्रदर्शित हों — ₹10,000+ दें",
      dialogTitle: "परिवर्तन-नायकों की दीवार से जुड़ें",
      dialogDesc: "₹10,000 या अधिक के एकमुश्त दान के लिए प्रदर्शित। (मासिक ₹2,000 × 5 दानदाता 5वीं कटौती के बाद स्वतः जोड़े जाते हैं।)",
      name: "आपका नाम", donationAmount: "एकमुश्त दान राशि (₹)", choosePhoto: "एक फ़ोटो चुनें",
      submit: "मुझे दीवार पर जोड़ें", uploading: "अपलोड हो रहा है...",
      featured: "प्रदर्शित दानदाता", founding: "संस्थापक दानदाता",
      minError: "यह दीवार ₹10,000+ के एकमुश्त दान, या 5 महीनों में पूर्ण ₹2,000/माह के लिए है।",
      needPhoto: "कृपया एक फ़ोटो चुनें।", success: "परिवर्तन-नायकों की दीवार में आपका स्वागत है! 🙏",
      empty: "हमारी दीवार पर पहला चेहरा बनें।",
      emptyDesc: "अभी तक कोई परिवर्तन-नायक प्रदर्शित नहीं — ₹10,000 या अधिक का दान आपकी फ़ोटो को यहाँ सबसे पहले लाता है।",
    },
    footer: { getInTouch: "संपर्क करें", title: "आपकी करुणा का यहाँ एक घर है।", donateNow: "अभी दान करें", admin: "एडमिन", explore: "अन्वेषण करें", contactCol: "संपर्क" },
  },
};
